/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";
import Button from "../elements/Button";
import logo from "../assets/images/logo193.png";

export default function BrandIcon() {
  return (
    <Button className="" type="link" href="/">
    <img src={logo} alt="Guvrn Logo" className="h-14 w-auto rounded-2xl" />
    </Button>
  );
}
